import { InjectionToken } from '@angular/core';
import { InfrastructureConfig } from './infrastructure-config.model';

export const INFRASTRUCTURE_CONFIG = new InjectionToken<InfrastructureConfig>(
  'INFRASTRUCTURE_CONFIG'
);
